module.exports = __webpack_public_path__ + "static/media/1.88e552ac.png";